import IconCircleChecked from '@/asset/icons/icon-circle-checked';
import IconCircleUnchecked from '@/asset/icons/icon-circle-unchecked';
import { CircleCheckBoxStyled, IconWrapper } from './styled';

interface Props {
  label: React.ReactNode;
  checked?: boolean;
  onChange?: (checked: boolean) => void;
}

export const CircleCheckBox = (props: Props) => {
  const { label, checked, onChange } = props;
  return (
    <>
      <CircleCheckBoxStyled>
        <IconWrapper onClick={() => onChange && onChange(!checked)}>
          <span className={`icon checked ${checked ? 'visible' : ''}`}>
            <IconCircleChecked />
          </span>
          <span className={`icon unchecked ${!checked ? 'visible' : ''}`}>
            <IconCircleUnchecked />
          </span>
        </IconWrapper>
        {label}
      </CircleCheckBoxStyled>
    </>
  );
};
